import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

import "../styles/UserForm.css";
import logo from "../assets/logo.png";

const TempPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isValid, setIsValid] = useState(true);

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const now = Date.now() / 1000;

        if (decoded.exp && decoded.exp < now) {
          setErrorMessage("This link has expired. Please request a new password reset.");
          setIsValid(false);
          return;
        }
        setPassword(decoded.password);
      } catch (err) {
        setErrorMessage("Invalid or expired link. Please raise a new forgot password request.");
        setIsValid(false);
      }
    }
  }, [token]);

  return (
    <div className="page">
      <div className="card">
        <center>
          <img src={logo} alt="Manis Logo" className="logo" />
        </center>

        <h2 className="title">
          <center>Temporary Password</center>
        </h2>

        {errorMessage && <div className="error">{errorMessage}</div>}

        {isValid && (
          <div className="temp-password-content">

            <p>
              Your password has been successfully reset. Please use the temporary password
              below to log in to the system.
            </p>

            <div className="temp-pin-box">
              <span className="pin"><strong>{password}</strong></span>
            </div>

            <p className="note">
              For security reasons, please change your password immediately after logging in.
            </p>

            <div style={{ marginTop: "20px" }}>
              <a
                href="/login"
                style={{
                  color: "#0b5ed7",
                  textDecoration: "underline",
                  fontWeight: "bold"
                }}
              >
                Go to Login Page
              </a>
            </div>

            <p className="signature">
              <br />
              Regards,<br />
              <strong>MDB Team</strong>
            </p>

          </div>
        )}
      </div>
    </div>
  );
};

export default TempPassword;
